interface Form {
  email: string
  firstName: string
}

export default async (form: Form) => {
  const runtimeConfig = useRuntimeConfig()

  return await $fetch('/store-api/newsletter/subscribe', {
    method: 'POST',
    body: {
      ...form,
      storefrontUrl: runtimeConfig.public.storefrontUrl,
      option: 'direct'
    }
  })
}